import LinkedinAuth from "./LinkedinAuth";

export default LinkedinAuth;
